// Get API base URL from environment variable
// Defaults to relative path for production, or localhost for development
export const API_BASE_URL = 
  import.meta.env.VITE_API_BASE_URL || 
  (import.meta.env.DEV ? "http://localhost:8000/api" : "/api");

